module.exports = {
    topHead: {
        select_option_category: "类目",
        select_option_category_holder: "请选择类目",
        select_option_brand: "品牌",
        select_option_brand_holder: "请选择",
        select_option_postKeyWords: "帖子关键词",
        select_option_postKeyWords_holder: "请输入内容",
        rules_message_search: "品牌和帖子内容至少输入一个",
        my_attention: "我的关注",
        login_label: "登录",
        login_out: "退出",
        Chinese: "中文",
        English: "English",
    },
};